import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Frown = createReactComponent("Frown", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}], ["path", {
  d: "M16 16s-1.5-2-4-2-4 2-4 2",
  key: "1kaepz"
}], ["line", {
  x1: "9",
  y1: "9",
  x2: "9.01",
  y2: "9",
  key: "sl5tun"
}], ["line", {
  x1: "15",
  y1: "9",
  x2: "15.01",
  y2: "9",
  key: "136pav"
}]]]);
export default Frown;